<template>
  <div class="splash" v-if="hideSplash === false" :class="{'ready': windowLoading === false}">
    <img src="@/assets/logo.svg" alt="Logo">

  </div>
  <!-- windowReady: false,
  windowLoading: true -->
  <div class="page-container" :class="{'loading': windowReady === true}">
    <header class="set-width">
      <h1>Appmosphere<span>.</span></h1>

      <div class="icon-groups">

        <button class="button" @click="saveBrandMixPannel()" v-if="$store.state.userToken.allowCheck === 'zPp71fUxunekfWkA083fZ2ZoUaw1' ">
          <span class="material-symbols-rounded"> &#xf884; </span>
          <div class="tooltip">Create Brand Mix</div>
        </button>

        <button class="button" @click="sleeptimer()" :class="{timeActive: countdownTime }">
          <span class="material-symbols-rounded"> &#xe425; </span>
          <div class="tooltip">Sleep Timer <span v-if="countdownTime">{{countdownTime}}</span></div>
        </button>

        <button class="button" @click="pageURL = 'home', viewingPage = null" :class="{'active': pageURL === 'home'}">
          <span class="material-symbols-rounded"> &#xe429; </span>
          <div class="tooltip">Sound Mixer</div>
        </button>

        <button class="button" @click="pageURL = 'explore', viewingPage = null" :class="{'active': pageURL === 'explore'}">
          <span class="material-symbols-rounded"> &#xe87a; </span>
          <div class="tooltip">Explore Sounds</div>
        </button>

        <button class="button" @click="account()">
          <span class="material-symbols-rounded"> &#xe853; </span>
          <div class="tooltip">Account</div>
        </button>
      </div>
    </header>


    <div class="home" v-show="pageURL === 'home' || pageURL === 'singlePage'">
      <CustomSounds ref="customSoundMixer"/>
    </div>
    <div class="explore" v-if="pageURL === 'explore'">
      <ExploreSounds />
    </div>

  </div>

  <div class="saveNotification" v-show="showSaveMessage">
    <svg width="140" height="139" viewBox="0 0 140 139" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="139" height="139" rx="69.5" fill="#161728" fill-opacity="0.6"/>
      <path d="M35.3645 74.4479C34.0451 74.4479 32.8906 73.9531 31.901 72.9635C30.9114 71.9739 30.4166 70.8194 30.4166 69.5C30.4166 68.1805 30.9114 67.026 31.901 66.0364C32.8906 65.0468 34.0451 64.552 35.3645 64.552C36.684 64.552 37.8385 65.0468 38.8281 66.0364C39.8177 67.026 40.3125 68.1805 40.3125 69.5C40.3125 70.8194 39.8177 71.9739 38.8281 72.9635C37.8385 73.9531 36.684 74.4479 35.3645 74.4479ZM40.5104 94.6354L53.375 81.7708C53.9687 81.177 54.6614 80.8967 55.4531 80.9296C56.2447 80.9626 56.9375 81.276 57.5312 81.8697C58.125 82.4635 58.4218 83.1727 58.4218 83.9974C58.4218 84.822 58.125 85.5312 57.5312 86.125L44.6666 98.9895C44.0729 99.5833 43.3802 99.8637 42.5885 99.8307C41.7968 99.7977 41.1041 99.4843 40.5104 98.8906C39.9166 98.2968 39.6198 97.5876 39.6198 96.763C39.6198 95.9383 39.9166 95.2291 40.5104 94.6354ZM53.375 56.9322L40.5104 44.1666C39.9166 43.5729 39.6362 42.8802 39.6692 42.0885C39.7022 41.2968 40.0156 40.6041 40.6093 40.0104C41.2031 39.4166 41.9123 39.1198 42.7369 39.1198C43.5616 39.1198 44.2708 39.4166 44.8645 40.0104L57.6302 52.776C58.2239 53.3697 58.5208 54.0625 58.5208 54.8541C58.5208 55.6458 58.2239 56.3385 57.6302 56.9322C57.0364 57.526 56.3272 57.8229 55.5026 57.8229C54.6779 57.8229 53.9687 57.526 53.375 56.9322ZM70 109.083C68.6805 109.083 67.526 108.589 66.5364 107.599C65.5468 106.609 65.052 105.455 65.052 104.135C65.052 102.816 65.5468 101.661 66.5364 100.672C67.526 99.6822 68.6805 99.1875 70 99.1875C71.3194 99.1875 72.4739 99.6822 73.4635 100.672C74.4531 101.661 74.9479 102.816 74.9479 104.135C74.9479 105.455 74.4531 106.609 73.4635 107.599C72.4739 108.589 71.3194 109.083 70 109.083ZM70 39.8125C68.6805 39.8125 67.526 39.3177 66.5364 38.3281C65.5468 37.3385 65.052 36.184 65.052 34.8645C65.052 33.5451 65.5468 32.3906 66.5364 31.401C67.526 30.4114 68.6805 29.9166 70 29.9166C71.3194 29.9166 72.4739 30.4114 73.4635 31.401C74.4531 32.3906 74.9479 33.5451 74.9479 34.8645C74.9479 36.184 74.4531 37.3385 73.4635 38.3281C72.4739 39.3177 71.3194 39.8125 70 39.8125ZM82.4687 52.677L95.2343 39.9114C95.8281 39.3177 96.5208 39.0373 97.3125 39.0703C98.1041 39.1033 98.7968 39.4166 99.3906 40.0104C99.9843 40.6041 100.281 41.3133 100.281 42.138C100.281 42.9626 99.9843 43.6718 99.3906 44.2656L86.625 57.0312C86.0312 57.625 85.3385 57.9053 84.5468 57.8724C83.7552 57.8394 83.0625 57.526 82.4687 56.9322C81.875 56.3385 81.5781 55.6293 81.5781 54.8046C81.5781 53.98 81.875 53.2708 82.4687 52.677ZM95.2343 98.7916L82.3697 86.026C81.776 85.4322 81.4956 84.7395 81.5286 83.9479C81.5616 83.1562 81.875 82.4635 82.4687 81.8697C83.0625 81.276 83.7717 80.9791 84.5963 80.9791C85.421 80.9791 86.1302 81.276 86.7239 81.8697L99.4895 94.6354C100.083 95.2291 100.38 95.9218 100.38 96.7135C100.38 97.5052 100.083 98.1979 99.4895 98.7916C98.8958 99.3854 98.1866 99.6823 97.3619 99.6823C96.5373 99.6823 95.8281 99.3854 95.2343 98.7916ZM104.635 74.4479C103.316 74.4479 102.161 73.9531 101.172 72.9635C100.182 71.9739 99.6875 70.8194 99.6875 69.5C99.6875 68.1805 100.182 67.026 101.172 66.0364C102.161 65.0468 103.316 64.552 104.635 64.552C105.955 64.552 107.109 65.0468 108.099 66.0364C109.089 67.026 109.583 68.1805 109.583 69.5C109.583 70.8194 109.089 71.9739 108.099 72.9635C107.109 73.9531 105.955 74.4479 104.635 74.4479Z" fill="white"/>
      <path d="M69.8978 85.7C69.6338 85.7 69.3698 85.652 69.1059 85.556C68.8419 85.46 68.614 85.3161 68.422 85.1241L66.5143 83.3604C63.5387 80.6008 60.9591 77.9672 58.7755 75.4596C56.5918 72.952 55.5 70.3304 55.5 67.5948C55.5 65.4352 56.2259 63.6294 57.6777 62.1777C59.1294 60.7259 60.9232 60 63.0588 60C64.2826 60 65.4944 60.294 66.6943 60.8819C67.8941 61.4698 68.9619 62.4356 69.8978 63.7794C70.9536 62.4356 72.0454 61.4698 73.1732 60.8819C74.3011 60.294 75.4889 60 76.7367 60C78.8724 60 80.6661 60.7259 82.1179 62.1777C83.5696 63.6294 84.2955 65.4352 84.2955 67.5948C84.2955 70.3304 83.2037 72.952 81.02 75.4596C78.8364 77.9672 76.2568 80.6008 73.2812 83.3604L71.3735 85.1241C71.1816 85.3161 70.9536 85.46 70.6896 85.556C70.4257 85.652 70.1617 85.7 69.8978 85.7Z" fill="#EC6A5E"/>
    </svg>

    Sound mix saved!</div>

  <div class="stoppedAllSounds" v-show="stoppedAllSounds">All sounds stopped</div>

  <PlayBar v-show="playingCount >= 1"/>
  <UpgradeAccount class="upgradeModel login" v-if="upgrade"/>
  <AccountLogin class="upgradeModel login" v-if="login"/>
  <accountView class="upgradeModel login account" v-if="accountView"/>
  <div class="loggedInNoti stoppedAllSounds" v-show="loggedInNoti">You have successfully signed in</div>
  <div class="loggedOutNoti stoppedAllSounds" v-show="loggedOutNoti">You have successfully signed out</div>


  <timerModal class="upgradeModel login account" v-show="TimerModal == true"/>
  <saveMix v-if="saveMix == true"/>
  <saveBrand v-if="saveBrandMix == true"/>
  <updateMixName v-if="updateMixNameModal == true"/>




  <div class="overlay" v-if="upgrade || login || accountView || saveMix || saveBrandMix || updateMixNameModal || TimerModal || filters" @click="overlayToggle()"></div>

</template>

<script>
import PlayBar from '@/components/PlayBar.vue';
import AccountLogin from '@/components/AccountLogin.vue';
import UpgradeAccount from '@/components/UpgradeAccount.vue';
import accountView from '@/components/accountView.vue';
import store from '@/store'


import CustomSounds from '@/views/CustomSounds.vue';
import ExploreSounds from '@/views/ExploreSounds.vue';
import saveMix from '@/components/saveMix.vue';
import saveBrand from '@/components/saveBrandMix.vue';
import updateMixName from '@/components/UpdateMixName.vue';
import timerModal from '@/components/TimerModal.vue';

export default {
  components: {
    AccountLogin,
    accountView,
    PlayBar,
    CustomSounds,
    ExploreSounds,
    saveMix,
    saveBrand,
    updateMixName,
    timerModal,
    UpgradeAccount
  },
  data() {
    return {
      showSaveMessage: false,
      stoppedAllSounds: false,
      upgrade: false,
      overlay: false,
      login: false,
      accountView: false,
      loggedInNoti: false,
      loggedOutNoti: false,
      currentSoundMix: null,
      saveAdjustedMix: false,
      playingCustomMixId: null,
      pageURL: 'explore',
      viewingPage: null,
      saveMix: false,
      saveBrandMix: false,
      playingCount: 0,
      updateMixNameModal: false,
      updateMixNameModalID: null,
      updateMixNameItemName: null,
      TimerModal: false,
      countdownTime: 0,
      filters: false,
      scrolling: false,
      isSafari: false,
      windowReady: false,
      windowLoading: true,
      hideSplash: false,
      customAdjustedItems: 0,

    };
  },
  mounted: function() {
   this.onLoad()
  },
  methods: {
    onLoad() {
      const globalThis = this
      if (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS')) {
        this.isSafari = true
      }

      setTimeout(function() {
        globalThis.windowReady = true
        globalThis.windowLoading = false
      }, 1000);
      setTimeout(function() {
        globalThis.hideSplash = true
      }, 2000);

    },
    saveBrandMixPannel() {
      this.saveBrandMix = true;
    },
    sleeptimer() {
      console.log("sd")
      this.TimerModal = !this.TimerModal
    },
    account() {
      if (store.state.userToken.signedin === false) {
        this.login = true
      } else {
        this.accountView = true
      }
    },
    overlayToggle() {
      this.upgrade = false;
      this.overlay = false;
      this.login = false;
      this.accountView = false;
      this.saveMix = false;
      this.saveBrandMix = false;
      this.updateMixNameModal = false
      this.updateMixNameItemName = null
      this.TimerModal = false
      this.filters = false
      this.upgrade = false
    },
    upgradeAccount() {
      this.overlayToggle()
      this.upgrade = true
    },

  }
};
</script>



<style lang="scss">
@import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');
.material-symbols-rounded {
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 200, "opsz" 48;
}

:root {
  //Button colours
  --primary-color: #FCD651;
  --base-font-colour: #9D9EB6;
  --navigation-background-color: #23263D;
  --navigation-background-border: #2C2F5B;

  --body-background: #161728;
  --body-background-colour-top: #131357;
  --body-background-colour-bottom: #161728;

  --mixer-background: #23263D;
  --mixer-border: #2C2C51;
  --mixer-bar: #353685;
}


h1, .h1 {
	font-size: 20px;
}

h2, .h2 {
	font-size: 22px;
  margin-top: 0;
}

h3, .h3 {
	font-size: 1.8em;
}


html {
	color: #ffffff;
	-webkit-transition: all ease-in-out 0.2s;
	transition: all ease-in-out 0.2s;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  min-height: 600px;
  overflow: hidden;

}
body {
	margin: 0;
	padding: 0;
  width: 100%;
	font-family: 'Manrope', sans-serif !important;
	font-size: 16px;
	line-height: 1.3em;
	font-weight: 500;
	background-color: #FAFAFB;
  background: var(--body-background);
  position: relative;
  background-image: url('@/assets/glow.svg');
  background-position: right bottom;
  background-size: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
.required {
  color: #ff6c51;
  text-align: center;
  margin-top: 0;
}

.savedMixChanged {
  position: absolute;
  z-index: 6;
  right: 16px;
  margin: auto;
  bottom: 22px;
  width: -moz-max-content;
  width: max-content;
  display: flex;
  align-items: center;
  border-radius: 8px;

  .button {
    margin: 0 !important;

  }
}
#app {
  margin: 0;
  position: relative;
  padding: 0;
  height: 100%;
  display: flex;

    .page-container {

      &.loading {
        animation-name: windowLoadIn;
        animation-duration: 1s;
      }

    }



  nav {
    width: 100px;
    background-color: var(--navigation-background-color);
    border-right: solid 1px var(--navigation-background-border);
    padding: 20px 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .top {
      display: flex;
      flex-direction: column;
    }
  }
  .icon-groups {
    display: flex;
    .button {
      appearance: none;
      background: none;
      border: none;
      outline: none;
    }
  }

  .button {
    padding: 12px;
    margin: 8px;
    color: #ffffff;
    display: flex;
    text-decoration: none;
    border-radius: 12px;
    font-size: 26px;
    cursor: pointer;
    position: relative;

    @media only screen and (max-width: 650px) {
      margin: 2px;
    }

    &.active {
      background: #2C2F5B;
      span {
        font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 200, "opsz" 48;
      }
    }
    &.timeActive {
      border: solid 1px var(--primary-color);
      background: none;
      color: var(--primary-color);
      span {
        font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 200, "opsz" 48;
      }
    }
    &:hover{
      background: #2C2F5B;
      span {
        font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 200, "opsz" 48;
      }
      div {
        display: block;

        @media only screen and (max-width: 650px) {
          display: none;
        }
      }
    }
    &:focus-visible {
     background: var(--mixer-bar);
     span {
       font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 200, "opsz" 48;
     }
     div {
       display: block;
     }
   }

   // Tooltip
    div {
      display: none;
      position: absolute;
      bottom: -45px;
      margin: auto;
      right: 0;
      width: max-content;
      font-size: 14px;
      background: var(--navigation-background-color);
      padding: 8px 12px;
      border-radius: 8px;
    z-index: 9999;
    }

  }

  .page-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 4px 0px 0px 0px;
    position: relative;
    background-image: url('@/assets/stars.svg');
    background-position: left top;
    background-size: 100%;
    background-repeat: no-repeat;
    overflow: hidden;

    @media only screen and (max-width: 1024px) {
      padding: 0;
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 95px;
      padding: 8px 14px;

      @media only screen and (max-width: 1024px) {
        min-height: 65px;
      }

      h1 {
        font-weight: bold;
        span {
          font-size: 44px;
          color: var(--primary-color);
          @media only screen and (max-width: 1024px) {
            margin-top: -5px;
            font-size: 28px;
          }
        }
        @media only screen and (max-width: 1024px) {
          font-size: 20px;
          display: flex;
          margin: 8px;
        }
        @media only screen and (max-width: 650px) {
          font-size: 14px;
        }

      }
      .actions {
        display: flex;
        align-items: center;
      }
    }
    .set-width {
      max-width: 1501px;
      padding: 0 14px;
      margin: 0 auto;
      width: calc(100% - 28px);

      @media only screen and (max-width: 1024px) {

        margin: 0;
        height: 100%;
      }

    }

    .home {
      height: 100%;
      max-width: 1501px;
      width: calc(100% - 28px);
      margin: auto;
      padding: 0 14px;
      @media only screen and (max-width: 1024px) {
        padding: 0;
      }
    }
  }

  .page-content {
    display: flex;
    height: 100%;

    .body {
      width: 100%;
      padding: 0;
      .copy {
        margin: auto;
        margin-top: 65px;
        margin-bottom: 0;
        position: relative;
        // padding: 0 8px;
        max-width: calc(1501px - 26px);

        @media only screen and (max-width: 650px) {
          margin-top: 20px;
        }

        h2 {
        }
        p {
          color: var(--base-font-colour);
        }

      }
      .view-page {
        + .overflow {
          max-height: calc(100vh - 394px);
        }
      }
      .overflow {
        // max-height: calc(100vh - 369px);
        overflow: auto;
        padding-bottom: 100px;
        // margin-right: 22px;
        &.noScroll:not(.safari) {
          overflow: hidden;
          width: calc(100% - 23px);
        }

        @media only screen and (max-width: 1024px) {
          width: 100%;
          margin: 0;
          max-height: calc(100% - 165px);
        }

        /* width */
        &::-webkit-scrollbar {
          width: 8px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 8px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #2C2F5B;
          border-radius: 8px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #3a3e7a;
        }

        .sound-row {
          margin-top: 84px;
          padding: 0 8px;
          &:first-child {
            margin-top: 38px;

          }
          .mixers {
            display: flex;
            margin-top: 32px;
            flex-wrap: wrap;
            gap: 60px 0px;
            padding-left: 1px;
            @media only screen and (max-width: 650px) {
              gap: 50px 0px;
            }
          }
        }
      }

    }
    .right-hand-navigation {
      flex-direction: column;
      align-items: flex-end;
      height: calc(100vh - 104px);
      min-width: 300px;


      @media only screen and (min-width: 1025px) {
        display: flex;
      }
      @media only screen and (max-width: 1024px) {
        display: none;
        &.active {
          display: flex;
        }
        position: fixed;
        right: 22px;
        margin-right: -22px;
        z-index: 9;
        background: var(--mixer-border);
        padding: 20px;
        top: 0;
        height: 100vh;
        > .presets {
          padding-top: 20px !important;
        }
        animation-name: pannel-in;
        animation-duration: 0.5s;
      }

      .actions {
        display: flex;
        top: -67px;
        right: 222px;
        position: relative;
      }
      .presets {
        overflow: auto;
        padding-right: 10px;
        padding-top: 60px;
        max-width: 290px;
        width: calc(100% - 20px);
        height: calc(100% - 100px);
        /* width */
        &::-webkit-scrollbar {
          width: 8px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 8px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: var(--base-font-colour);
          border-radius: 8px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #3a3e7a;
        }
        .preset-title {
          text-align: right;
          padding: 18px 8px 8px 8px;
          border-top: solid 1px var(--navigation-background-border);
          margin-top: 12px;
        }

        ul {
          margin: 0;
          padding: 0;
          li {
            margin: 0;
            padding: 0;
            list-style: none;
            text-align: right;
            padding: 8px;
            color: var(--base-font-colour);
            font-family: 'Manrope', sans-serif !important;
            font-size: 18px;
            font-weight: normal;
            cursor: pointer;
            position: relative;
            &.active {
              color: var(--primary-color) !important;
            }
            &:hover {
              color: var(--primary-color);
            }
          }

        }
      }
    }
  }

  .saveNotification {
    position: absolute;
    bottom: 22px;
    right: 22px;
    max-width: 350px;
    max-height: 40px;
    margin: auto;
    padding: 12px 22px;
    border-radius: 8px;
    background: var(--navigation-background-border);
    color: #d1d2e6;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    animation-name: fadeIn-bottom;
    animation-duration: 0.5s;
    svg {
      margin-right: 12px;
      max-width: 50px;
      margin-left: -12px;
    }
  }

  .stoppedAllSounds {
    position: absolute;
    bottom: 22px;
    right: 22px;
    padding: 12px 22px;
    border-radius: 8px;
    background: var(--primary-color);
    color: #000000;
    opacity: 1;
    animation-name: fadeIn-bottom;
    animation-duration: 0.5s;
    z-index: 5;
  }

.savePannel {
  background: rgb(35,38,61);
  background: -moz-linear-gradient(180deg, rgba(35,38,61,1) 0%, rgba(61,35,54,1) 100%);
  background: -webkit-linear-gradient(180deg, rgba(35,38,61,1) 0%, rgba(61,35,54,1) 100%);
  background: linear-gradient(180deg, rgba(35,38,61,1) 0%, rgba(61,35,54,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#23263d",endColorstr="#3d2336",GradientType=1);

  position: absolute;
  border: solid 1px var(--navigation-background-border);
  top: 22px;
  right: 22px;
  height: calc(100% - 88px);
  width: 100%;
  max-width: 350px;
  margin: auto;
  padding: 22px;
  border-radius: 8px;
  color: #d1d2e6;
  z-index: 5;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 18px;
  animation-name: pannel-in;
  animation-duration: 0.5s;

.header {
  width: 100%;
  padding-bottom: 10px;
  margin-top: 0;
  margin-bottom: 44px;
  border-bottom: solid 1px var(--navigation-background-border);
  display: flex;
  justify-content: space-between;

  h2 {
    margin: 10px 0px 0px 0px;
  }
  span {
    padding: 12px;
    margin: -4px 0px 0px 0px;
    color: #ffffff;
    display: flex;
    text-decoration: none;
    border-radius: 12px;
    font-size: 26px;
    cursor: pointer;

    &:hover {
      background: #2C2F5B;

    }

  }
}

  .intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      text-align: center;
    }
  }
  form {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .input-group {
      display: flex;
      flex-direction: column;
      margin: 44px 12px;

      [type="text"],  select {
        height: 55px;
        border-radius: 8px;
        background: none;
        border: solid 1px #36395c;
        padding: 0px 22px;
        color: #ffffff;
        font-family: "Manrope", sans-serif !important;
        font-size: 16px;
        margin-bottom: 16px;

        &:not(:disabled) {
          &:hover {
            border: solid 1px #4e5387;
          }
          &:active {
            border: solid 1px #4e5387;
          }
          &:focus {
            z-index: 1;
            position: relative;
            outline: none;
            box-shadow:0 0 0 3px #c09707;
          }
        }
      }

      .checkbox-group {
        margin: 22px 0px;
        display: flex;
        gap: 8px;
        justify-content: center;

        input {
          height: 22px;
          width: 22px;
          border-radius: 3px;
          appearance: none;
          border: solid 1px #fff;
          &:checked {
            background: var(--primary-color);
            border: solid 1px var(--primary-color);
            background-image: url('@/assets/icons/check.svg');
            background-size: 100%;
          }
          &:not(:disabled) {
            &:hover {
              border: solid 1px #929295;
            }
            &:active {
              border: solid 1px #929295
            }
            &:focus {
              z-index: 1;
              position: relative;
              outline: none;
              box-shadow:0 0 0 3px #c09707;
            }
          }
        }
        label {
          padding-top: 4px;
          font-size: 16px;
        }
      }
    }
    button {
      height: 55px;
      border-radius: 8px;
      background: var(--primary-color);
      font-weight: bold;
      font-size: 18px;
      font-family: "Manrope", sans-serif !important;
      border: none;
      transition: all ease-in-out 0.2s;

      &:not(:disabled) {
        &:hover {
          background-color: #deb320;
        }
        &:active {
          background-color: #efc32b;
        }
        &:focus {
          z-index: 1;
          position: relative;
          outline: none;
          box-shadow:0 0 0 3px #c09707;
        }
      }

    }
  }

}


  .upgradeModel, .updateName-form {
    background: rgb(35,38,61);
    background: -moz-linear-gradient(180deg, rgba(35,38,61,1) 0%, rgba(61,35,54,1) 100%);
    background: -webkit-linear-gradient(180deg, rgba(35,38,61,1) 0%, rgba(61,35,54,1) 100%);
    background: linear-gradient(180deg, rgba(35,38,61,1) 0%, rgba(61,35,54,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#23263d",endColorstr="#3d2336",GradientType=1);
    position: absolute;
    border: solid 1px #36374c;
    top: 22px;
    right: 22px;
    left: 22px;
    bottom: 22px;
    height: fit-content;
    // width: 100%;
    max-width: 450px;
    margin: auto;
    padding: 42px;
    border-radius: 8px;
    color: #d1d2e6;
    z-index: 5;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    animation-name: fadeIn-bottom;
    animation-duration: 0.2s;
    @media only screen and (max-width: 650px) {
      top: 12px;
      right: 12px;
      left: 12px;
      bottom: 12px;
      padding: 27px 18px 18px 18px !important;
    }
    .close {
      position: absolute;
      top: 22px;
      right: 22px;
      padding: 8px;
      margin: 0;
      color: #ffffff;
      display: flex;
      text-decoration: none;
      border-radius: 12px;
      font-size: 26px;
      cursor: pointer;
      &:hover {
        background: #2C2F5B;
      }
    }

    .header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 22px;
      padding-top: 0;
      width: 100%;


      @media only screen and (max-width: 650px) {
        align-items: flex-start;
        padding-left: 0;
        padding-right: 70px;
        * {
          text-align: left !important;
        }
        br {
          display: none;
        }
      }
      span {
        font-size: 42px;
        color: #ffff;
      }
      h2 {
        font-family: "Manrope", sans-serif !important;
        font-weight: 600;
        color: #ffff;
      }
      p {
        color: #9D9EB6;
        font-family: "Manrope", sans-serif !important;
        font-weight: normal;
        text-align: center;
        font-size: 16px;
        margin: 0;
      }
    }


    .feature-container {
      display: flex;
      width: 100%;
      margin: 22px 0px 34px 0px;
      gap: 22px;

      .item {
        span {
          font-size: 44px;
          font-variation-settings: 'FILL' 0, 'wght' 300, 'GRAD' 200, 'opsz' 48;
        }
        border: solid 1px #4C4F79;
        padding: 22px;
        font-size: 16px;
        color: #ffffff;
        border-radius: 8px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 12px;
        transition: all ease-in-out 0.2s;

        strong {
          font-family: "Manrope", sans-serif !important;
          font-weight: normal;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.05);
        }
      }
    }

    button {
      height: 55px;
      width: 100%;
      border-radius: 8px;
      background: var(--primary-color);
      font-weight: 900;
      font-size: 18px;
      font-family: "Manrope", sans-serif !important;
      border: none;
      transition: all ease-in-out 0.2s;
      cursor: pointer;

      &:not(:disabled) {
        &:hover {
          background-color: #deb320;
        }
        &:active {
          background-color: #efc32b;
        }
        &:focus {
          z-index: 1;
          position: relative;
          outline: none;
          box-shadow:0 0 0 3px #c09707;
        }
      }

    }

    &.login {

      .header {
        padding-bottom: 24px;
        @media only screen and (max-width: 650px) {
          width: calc(100% - 70px) !important;
        }
        h2 {
          margin-top: 0;
          margin-bottom: 12px;
        }
        p {
          margin-top: 0;
          text-align: left;
          span {
            color: white;
            font-size: inherit;
            &:hover {
              color: var(--primary-color);
              cursor: pointer;
            }
          }
        }
      }
      .input-group {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 8px;

        input {
          height: 55px;
          border-radius: 8px;
          background: none;
          border: solid 1px #36395c;
          padding: 0px 22px;
          color: #ffffff;
          font-family: "Manrope", sans-serif !important;
          font-size: 16px;

          &:not(:disabled) {
            &:hover {
              border: solid 1px #4e5387;
            }
            &:active {
              border: solid 1px #4e5387;
            }
            &:focus {
              z-index: 1;
              position: relative;
              outline: none;
              box-shadow:0 0 0 3px #c09707;
            }
          }
        }
        label {
          padding-top: 4px;
          font-size: 16px;
        }

      }
      button {
        margin-top: 22px;
        margin-bottom: 12px;
      }

      &.account {
        .header{
          padding-bottom: 0px;
        }
      }
    }
  }

}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  background: black;
  opacity: 0.3;
  animation-name: fade-in;
  animation-duration: 0.2s;
}


#explore {
  .most-popular {

  }
  .brand-mixes {

  }
  .community-mixes {

  }
}

.splash {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--body-background);
  background-image: url('@/assets/glow.svg');
  background-position: right bottom;
  background-size: 100%;
  background-repeat: no-repeat;
  z-index: 999;
  opacity: 1;

  img {
    position: relative;
    bottom: 0px;
    animation-name: splash-load-in;
    animation-duration: 0.5s;
  }

  &.ready{
    animation-name: windowLoadOut;
    animation-duration: 1s;
  }

}



@keyframes pannel-in {
  0% {
    opacity: 0;
    right: -100%;
  }
  100% {
    opacity: 1;
    right: 22px;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.3;
  }
}
@keyframes windowLoadIn {
  0% {
    transform: scale(1.1) translate(0px, 60px);
  }
  100% {
    transform: scale(1) translate(0px, 0px);
  }
}
@keyframes windowLoadOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes splash-load-in {
  0% {
    opacity: 0;
    bottom: -30px;
  }
  100% {
    opacity: 1;
    bottom: 0px;
  }
}

</style>
